import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-516802f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "compute-wizard-input-accordion" }

import { IonAccordionGroup, IonAccordion, IonItem, IonLabel } from '@ionic/vue';
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComputeWizardInputAccordion',
  props: {
    title: { default: undefined },
    shouldBeOpen: { type: Boolean, default: false }
  },
  setup(__props: any) {

const isAccordionOpen = ref<boolean>(false);

const props = __props;

watch(props, (newValue) => {
  isAccordionOpen.value = newValue.shouldBeOpen;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonAccordionGroup), {
      class: "compute-wizard-input-accordion__accordion-group",
      onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', $event.detail.value !== undefined))),
      value: isAccordionOpen.value ? 'ion-accordion-0' : undefined
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonAccordion), { class: "compute-wizard-input-accordion__accordion" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonItem), {
              lines: "full",
              class: "compute-wizard-input-accordion__accordion-header-item",
              slot: "header"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), { class: "compute-wizard-input-accordion__accordion-header-label" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.title), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["value"])
  ]))
}
}

})